// extracted by mini-css-extract-plugin
export default {"header":"mL","discountBanner":"nL","logo":"oL","maincontainer":"pL","videocontainer":"qL","videowelcome":"rL","videowrapper":"sL","videosale":"tL","loadingcontainer":"uL","footer":"vL","footerbutton":"wL","video":"xL","logoname":"yL"};
    if(module.hot) {
      // 1743628927472
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  